
export const config = {
    dashboardId: process.env.DASHBOARD_ID || 'DA0001',
    websocketUrl: process.env.WEBSOCKET_URL,
}
